import _debounce from 'lodash-es/debounce';

/**
 * Creates a debounced function.
 *
 * @param {*} fn The function to call after timeout
 * @param {*} timeout The timeout in ms to debounce by. Defaults to 100ms.
 */
export const debounce = (fn, ms = 100) => _debounce(fn, ms);
